document.addEventListener("DOMContentLoaded", function () {
    
    var metaRobots = document.querySelector('meta[name="robots"][content="noindex, follow"]');

    if (metaRobots) {
        var canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.parentNode.removeChild(canonicalTag);
        }
    }
});

// Cart upsell carousel: equal slide heights (flex/CSS не всегда побеждают стили Swiper)
(function () {
  window.equalizeDrawerUpsellHeights = function (root) {
    if (!root) return;
    var slides = root.querySelectorAll('.swiper-slide');
    if (!slides.length) return;
    var i;
    for (i = 0; i < slides.length; i++) {
      slides[i].style.height = '';
    }
    /* Equal heights + margin-top:auto on the button = huge empty gap on narrow viewports */
    if (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767px)').matches) {
      return;
    }
    if (window.innerWidth <= 767) return;
    var max = 0;
    for (i = 0; i < slides.length; i++) {
      max = Math.max(max, slides[i].offsetHeight);
    }
    if (max < 1) return;
    for (i = 0; i < slides.length; i++) {
      slides[i].style.height = max + 'px';
    }
  };

  /* Slide width from CSS (@container, matches 1/2/3 per row). slidesPerView: auto — Swiper must not set inline width. */
  window.initDrawerProgressUpsell = function (root) {
    if (!root) root = document.querySelector('.drawer__progress_products');
    if (!root) return null;
    var navRoot = root.closest('.drawer__progress_products-block') || root.parentElement;

    if (root.swiper) root.swiper.destroy(true, true);

    function run() {
      if (typeof Swiper === 'undefined') return null;
      var swiper = new Swiper(root, {
        spaceBetween: 10,
        slidesPerView: 'auto',
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: navRoot.querySelector('.swiper-button-next'),
          prevEl: navRoot.querySelector('.swiper-button-prev'),
        },
      });
      if (window.equalizeDrawerUpsellHeights) window.equalizeDrawerUpsellHeights(root);
      root.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener(
          'load',
          function () {
            if (window.equalizeDrawerUpsellHeights) window.equalizeDrawerUpsellHeights(root);
            swiper.update();
          },
          { once: true }
        );
      });
      return swiper;
    }

    if (window.ensureSwiperLoaded) {
      window.ensureSwiperLoaded(run);
      return null;
    }
    return run();
  };
})();

// product upsell variant buttons - поддержка товаров с опциями и без (инициализация при появлении секции в viewport)
(function () {
  const upsellContainer = document.querySelector('.product__upsell');
  if (!upsellContainer) return;

  function initUpsellVariants() {
  // Функция для генерации URL изображения с нужным размером (Shopify CDN)
  function getSizedImageUrl(src, size) {
    if (!src) return src;
    // const url = new URL(src);
    // return url.toString();
    return src;
  }

  const upsellItems = document.querySelectorAll('.product__upsell_item');

  upsellItems.forEach(upsellItem => {
    const buttons = upsellItem.querySelectorAll('.product__upsell_item_variant');
    const checkbox = upsellItem.querySelector('input[name="product__upsell"]');
    const variantsJson = upsellItem.dataset.variants;
    const priceEl = upsellItem.querySelector('.product__upsell_price');

    if (!checkbox || !variantsJson) {
      console.warn('Missing checkbox or variants for:', upsellItem);
      return;
    }

    const variants = JSON.parse(variantsJson);

    // Если нет опций (один вариант), ничего не делаем — value уже в Liquid
    if (!buttons.length) {
      return; // Skip further processing for single-variant products
    }

    function formatUpsellPrice(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      const currency = (priceEl?.textContent || '').replace(/[\d.,\s\u00A0-]/g, '').trim() || 'zł';
      const amount = (Number(cents) || 0) / 100;
      return `${amount.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`.trim();
    }

    function updateUpsellPrice(cents) {
      if (!priceEl) return;
      priceEl.textContent = formatUpsellPrice(cents);
    }

    // Функция для обновления чекбокса, цены и изображения
    function updateCheckbox() {
      const selectedOptions = {};
      const groups = upsellItem.querySelectorAll('.option-group');

      // Собираем выбранные значения
      groups.forEach(group => {
        const groupName = group.dataset.group;
        const optionIndex = parseInt(group.dataset.optionIndex) + 1; // option1, option2, ...
        const activeButton = group.querySelector('.product__upsell_item_variant.active');
        if (activeButton) {
          selectedOptions[`option${optionIndex}`] = activeButton.dataset.value;
        }
      });

      // Ищем вариант
      const matchingVariant = variants.find(variant => {
        return Object.keys(selectedOptions).every(key => {
          return variant[key] === selectedOptions[key];
        });
      });

      if (matchingVariant) {
        checkbox.value = matchingVariant.id;
        checkbox.dataset.price = matchingVariant.price;
        updateUpsellPrice(matchingVariant.price);

        // Обновляем только основное изображение, если есть featured_image
        if (matchingVariant.featured_image && matchingVariant.featured_image.src) {
          const src = matchingVariant.featured_image.src;
          const mainImg = upsellItem.querySelector('.product__upsell_image');
          if (mainImg) {
            mainImg.src = getSizedImageUrl(src, 300);
          }
        }
      } else {
        console.warn('No matching variant found for:', selectedOptions);
        checkbox.value = variants[0].id; // Fallback на первый вариант
        checkbox.dataset.price = variants[0].price;
        updateUpsellPrice(variants[0].price);
        // Для fallback тоже обновляем только основное изображение первого варианта
        if (variants[0].featured_image && variants[0].featured_image.src) {
          const src = variants[0].featured_image.src;
          const mainImg = upsellItem.querySelector('.product__upsell_image');
          if (mainImg) {
            mainImg.src = getSizedImageUrl(src, 300);
          }
        }
      }
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {

        const groupContainer = btn.closest('.option-group');
        if (!groupContainer) return;

        const upsellItem = btn.closest('.product__upsell_item');
        if (!upsellItem) return;

        // Сбрасываем active в текущей группе
        groupContainer.querySelectorAll('.product__upsell_item_variant')
          .forEach(el => el.classList.remove('active'));

        const value = btn.dataset.value.trim();
        const isMontazGroup = btn.dataset.group === 'Montaz';
        const isZamontowana = isMontazGroup && value.includes('+');
       if (isZamontowana && isMontazGroup) {

        document.querySelectorAll('.product__upsell_item').forEach(item => {

          if (item === upsellItem) return;

          const montazGroup = item.querySelector('.option-group[data-group="Montaz"]');
          if (!montazGroup) return;

          const zamontowana = [...montazGroup.querySelectorAll('.product__upsell_item_variant')]
            .find(el => el.dataset.value.includes('+'));

          const niezamontowana = [...montazGroup.querySelectorAll('.product__upsell_item_variant')]
            .find(el => !el.dataset.value.includes('+'));

          if (zamontowana && niezamontowana) {

            // Меняем визуально
            zamontowana.classList.remove('active');
            niezamontowana.classList.add('active');

            // ⚠ обновляем чекбокс ЭТОГО айтема
            const groups = item.querySelectorAll('.option-group');
            const checkbox = item.querySelector('input[name="product__upsell"]');
            const variants = JSON.parse(item.dataset.variants);

            const selectedOptions = {};
            groups.forEach(group => {
              const idx = parseInt(group.dataset.optionIndex) + 1;
              const active = group.querySelector('.product__upsell_item_variant.active');
              if (active) selectedOptions[`option${idx}`] = active.dataset.value;
            });

            const matchingVariant = variants.find(v =>
              Object.keys(selectedOptions).every(k => v[k] === selectedOptions[k])
            );

            if (matchingVariant) {
              checkbox.value = matchingVariant.id;
              checkbox.dataset.price = matchingVariant.price;
              const otherPriceEl = item.querySelector('.product__upsell_price');
              if (otherPriceEl) {
                if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
                  otherPriceEl.textContent = window.Shopify.formatMoney(matchingVariant.price);
                } else {
                  const otherCurrency = otherPriceEl.textContent.replace(/[\d.,\s\u00A0-]/g, '').trim() || 'zł';
                  const otherAmount = (Number(matchingVariant.price) || 0) / 100;
                  otherPriceEl.textContent = `${otherAmount.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${otherCurrency}`.trim();
                }
              }
            }
          }
        });
      }


        // Активируем выбранную кнопку
        btn.classList.add('active');

        // Обновление Kolor
        if (groupContainer.dataset.group === 'Kolor') {
          const optionValueDiv = groupContainer.querySelector('.option_value');
          if (optionValueDiv) {
            optionValueDiv.textContent = btn.dataset.value;
          }
        }

        updateCheckbox();
        // Debounce: Montaż sync touches every heel card; updatePrices also rewrites sticky/ATC DOM.
        clearTimeout(window.__evmUpsellPriceT);
        window.__evmUpsellPriceT = setTimeout(function () {
          const variantRadios = document.querySelector('variant-radios');
          if (variantRadios && typeof variantRadios.updatePrices === 'function') {
            variantRadios.updatePrices();
          }
        }, 50);
      });
    });

    // Инициализация только для товаров с опциями
    if (buttons.length) {
      updateCheckbox();
    }
  });
  }

  const upsellVariantsIO = new IntersectionObserver((entries, obs) => {
    if (!entries[0].isIntersecting) return;
    obs.disconnect();
    initUpsellVariants();
  }, { threshold: 0.1 });
  upsellVariantsIO.observe(upsellContainer);
})();
// video reviews
(function () {
    function hydrateVideoSource(video) {
        if (!video || video.src) return;
        var src = video.getAttribute('data-src');
        if (!src) return;
        video.src = src;
        video.removeAttribute('data-src');
    }

    var root = document.querySelector('.video_reviews');
    if (!root) return;
    var runVideoReviews = function () {
        if (typeof Swiper === 'undefined') return;
        var videoFullScreenContainer = root.querySelector('.video_reviews__container_full');
        var closeFullscreen = videoFullScreenContainer && videoFullScreenContainer.querySelector('.close');
        var mainEl = root.querySelector('.video_reviews__container_slider');
        if (!videoFullScreenContainer || !mainEl) return;

        var isVisible = false;
        var swiper = null;

        var toggleTrustbadgeClass = function (add) {
            var trustbadge = document.querySelector('[id*="trustbadge-container"]');
            if (!trustbadge) return;
            if (add) {
                trustbadge.classList.add('z_index_one');
            } else {
                trustbadge.classList.remove('z_index_one');
            }
        };

        if (closeFullscreen) {
            closeFullscreen.addEventListener('click', function () {
                videoFullScreenContainer.classList.remove('active');
                videoFullScreenContainer.querySelectorAll('video').forEach(function (video) {
                    video.pause();
                    video.currentTime = 0.1;
                    video.load();
                });
                if (swiper && swiper.autoplay) swiper.autoplay.start();
                toggleTrustbadgeClass(false);
            });
        }
        videoFullScreenContainer.addEventListener('click', function (e) {
            if (e.target.tagName !== 'VIDEO') {
                videoFullScreenContainer.classList.remove('active');
                videoFullScreenContainer.querySelectorAll('video').forEach(function (video) {
                    video.pause();
                    video.currentTime = 0.1;
                    video.load();
                });
                if (swiper && swiper.autoplay) swiper.autoplay.start();
                toggleTrustbadgeClass(false);
            }
        });

        var videoPlay = function (slider, full) {
            if (!isVisible) return;
            if (!slider || !slider.el) return;
            slider.el.querySelectorAll('video').forEach(function (video) {
                video.pause();
            });
            var slide = slider.slides[slider.activeIndex];
            if (!slide) return;
            var video = slide.querySelector('video');
            if (video) {
                hydrateVideoSource(video);
                video.currentTime = 0.2;
                video.play().catch(function () {});
                video.volume = 0.08;
                if (!full) {
                    video.muted = true;
                }
            }
        };

        var swiper2 = new Swiper(videoFullScreenContainer, {
            loop: true,
            direction: 'vertical',
            slidesPerView: 1,
            mousewheel: {
                enabled: true,
                thresholdTime: 300,
            },
            on: {
                transitionEnd: function () {
                    if (this.el.classList.contains('active')) {
                        videoPlay(this, true);
                    }
                },
            },
        });

        var prevBtn = root.querySelector('.video_reviews__slider-bleed .eva-slider-nav--prev');
        var nextBtn = root.querySelector('.video_reviews__slider-bleed .eva-slider-nav--next');

        var mainOpts = {
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
            speed: 480,
            watchOverflow: true,
            centeredSlides: true,
            // centeredMode: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            thumbs: {
                swiper: swiper2,
            },
            on: {
                transitionEnd: function () {
                    videoPlay(this);
                },
                click: function () {
                    var clicked = this.clickedSlide;
                    if (!clicked) return;
                    var idxAttr = clicked.getAttribute('data-swiper-slide-index');
                    var slideRealIndex =
                        idxAttr !== null && idxAttr !== ''
                            ? parseInt(idxAttr, 10)
                            : NaN;
                    if (isNaN(slideRealIndex)) {
                        slideRealIndex =
                            typeof this.getSlideIndex === 'function'
                                ? this.getSlideIndex(clicked)
                                : this.clickedIndex;
                    }
                    var active = this.slides[this.activeIndex];
                    if (clicked !== active) {
                        this.slideToClickedSlide();
                    }
                    videoFullScreenContainer.classList.add('active');
                    if (typeof swiper2.slideToLoop === 'function') {
                        swiper2.slideToLoop(slideRealIndex, 0, false);
                    } else {
                        swiper2.slideTo(slideRealIndex, 0, false);
                    }
                    this.autoplay.stop();
                    toggleTrustbadgeClass(true);
                    setTimeout(function () {
                        videoPlay(swiper2, true);
                    }, 0);
                },
                init: function () {
                    this.slides.forEach(function (element) {
                        element.querySelectorAll('video').forEach(function (video) {
                            video.currentTime = 0.2;
                        });
                    });
                },
            },
        };
        if (prevBtn && nextBtn) {
            mainOpts.navigation = { nextEl: nextBtn, prevEl: prevBtn };
        }

        swiper = new Swiper(mainEl, mainOpts);

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                isVisible = entry.isIntersecting;
                if (isVisible) {
                    if (swiper && swiper.autoplay) swiper.autoplay.start();
                    videoPlay(swiper);
                } else {
                    if (swiper && swiper.autoplay) swiper.autoplay.stop();
                    if (swiper && swiper.slides) {
                        swiper.slides.forEach(function (slide) {
                            slide.querySelectorAll('video').forEach(function (video) {
                                video.pause();
                            });
                        });
                    }
                }
            });
        }, { threshold: 0.5 });

        observer.observe(mainEl);

        videoPlay(swiper);
    };
    var videoReviewsIO = new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        if (typeof window.ensureSwiperLoaded === 'function') {
            window.ensureSwiperLoaded(runVideoReviews);
        } else {
            runVideoReviews();
        }
    }, { threshold: 0.1 });
    videoReviewsIO.observe(root);
})();
// video reviews

function ensureSearchModelsJs(callback) {
  if (window.__evamatsSearchModelsLoaded) {
    if (callback) callback();
    return;
  }
  var url = window.__evamatsSearchModelsUrl;
  var existing = document.querySelector('script[src*="search_models.js"]');
  if (existing) {
    if (callback) {
      document.addEventListener('evamats:search-models-ready', callback, { once: true });
    }
    return;
  }
  if (!url) {
    if (callback) callback();
    return;
  }
  if (window.__evamatsSearchModelsLoading) {
    if (callback) {
      document.addEventListener('evamats:search-models-ready', callback, { once: true });
    }
    return;
  }
  window.__evamatsSearchModelsLoading = true;
  var script = document.createElement('script');
  script.src = url;
  script.defer = true;
  script.onload = function () {
    window.__evamatsSearchModelsLoaded = true;
    document.dispatchEvent(new Event('evamats:search-models-ready'));
    if (callback) callback();
  };
  script.onerror = function () {
    window.__evamatsSearchModelsLoading = false;
    document.dispatchEvent(new Event('evamats:search-models-error'));
    if (callback) callback();
  };
  document.body.appendChild(script);
}

function ensureProductConfigJs(callback) {
  if (window.__evamatsProductConfigLoaded) {
    if (callback) callback();
    return;
  }
  var url = window.__evamatsProductConfigUrl;
  if (!url) {
    if (callback) callback();
    return;
  }
  if (window.__evamatsProductConfigLoading) {
    if (callback) {
      document.addEventListener('evamats:product-config-ready', callback, { once: true });
    }
    return;
  }
  window.__evamatsProductConfigLoading = true;
  var script = document.createElement('script');
  script.src = url;
  script.defer = true;
  script.onload = function () {
    window.__evamatsProductConfigLoaded = true;
    document.dispatchEvent(new Event('evamats:product-config-ready'));
    if (callback) callback();
  };
  document.body.appendChild(script);
}

// toggle popup
(function () {
    if (document.querySelector('.popup_overlay')) { 
        document.addEventListener('DOMContentLoaded', function() {
            const openPopupBtn = document.querySelectorAll('.openPopup');
            const closePopupBtn = document.querySelectorAll('.popup_close_btn');
            const popupOverlay = document.querySelectorAll('.popup_overlay');
        
            openPopupBtn.forEach(btn => {
                btn.addEventListener('click', function() {
                    const targetId = btn.dataset.popup;
                    const popup = document.querySelector(`.popup_overlay#${targetId}`);
                    if (popup) popup.classList.add('show');
                    document.querySelector('html').classList.add('overflow-hidden');
                    if (targetId === 'popupOverlayApplicationForm') {
                        ensureProductConfigJs(function () {
                            requestAnimationFrame(function () {
                                var productConfigCss = document.getElementById('product-config-css');
                                if (productConfigCss) productConfigCss.media = 'all';
                            });
                        });
                    }
                });
            })
        
            closePopupBtn.forEach(el => {
                el.addEventListener('click', function() {
                    el.closest('.popup_overlay').classList.remove('show');
                    document.querySelector('html').classList.remove('overflow-hidden')
                });
            })
        
            popupOverlay.forEach(element => {
                element.addEventListener('click', function(event) {
                    if (event.target === element) {
                        popupOverlay.forEach(el => {
                            el.classList.remove('show');
                        })
                        document.querySelector('html').classList.remove('overflow-hidden')
                    }
                });
            });

            const individualAutoPopup = document.querySelector('.popup_overlay[data-auto-open-individual]');
            if (individualAutoPopup) {
                const storageKey = individualAutoPopup.getAttribute('data-auto-open-key');
                if (storageKey && !sessionStorage.getItem(storageKey)) {
                    individualAutoPopup.classList.add('show');
                    document.documentElement.classList.add('overflow-hidden');
                    sessionStorage.setItem(storageKey, '1');
                }
            }
        });
        
    }
})();
// toggle popup



// toggle class in upsell item (инициализация при появлении секции в viewport)
(function () {
    const upsellContainer = document.querySelector('.product__upsell');
    if (!upsellContainer) return;

    function syncUpsellItemActive(item) {
      if (!item) return;
      var inp = item.querySelector('input[name="product__upsell"], input[name="product__extras"]');
      if (!inp) return;
      item.classList.toggle('active', !!inp.checked);
    }

    function syncAllUpsellActives() {
      document.querySelectorAll('.product__upsell_item, .product__extras_item').forEach(syncUpsellItemActive);
    }

    function initUpsellToggle() {
        const inputs = document.querySelectorAll('.product__upsell input[name="product__upsell"], .product__extras input[name="product__extras"]');
        inputs.forEach(input => {
          input.addEventListener('change', () => {
            const upsellItem = input.closest('.product__upsell_item, .product__extras_item');
            syncUpsellItemActive(upsellItem);
            const variantRadios = document.querySelector('variant-radios');
            if (variantRadios && typeof variantRadios.updatePrices === 'function') {
              variantRadios.updatePrices();
            }
          });
        });
        // Restore / already-checked heels: options need .active (or :has checked CSS)
        syncAllUpsellActives();
    }

    const upsellToggleIO = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        initUpsellToggle();
    }, { threshold: 0.05 });
    upsellToggleIO.observe(upsellContainer);

    // Also sync when heel/extras step opens (wizard may show already-checked boxes)
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.product__dropdown_wr--heel, .product__dropdown_wr--extras, [data-dropdown="extras"]')) return;
      setTimeout(syncAllUpsellActives, 0);
      setTimeout(syncAllUpsellActives, 80);
    }, true);
    document.addEventListener('evm-mat-cfg-restored', syncAllUpsellActives);
    // Fallback if section never intersects before user jumps via Dalej
    setTimeout(function () {
      if (!upsellContainer.querySelector('.product__upsell_item.active') &&
          upsellContainer.querySelector('input[name="product__upsell"]:checked')) {
        initUpsellToggle();
      }
    }, 600);
})();
  // toggle class in upsell item

  (function () {
    const comparisonSection = document.querySelector('.comparison');

    if (!comparisonSection) return;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                observer.unobserve(comparisonSection); // Отключаем наблюдение после инициализации
                initComparison();
            }
        });
    }, { threshold: 0.2 });

    observer.observe(comparisonSection);

    function initComparison() {
        let commonProgress = 0.5; // Глобальное значение прогресса для всех ползунков
        const blocks = document.querySelectorAll('.comparison__block');

        const isElementInViewport = (el) => {
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        };

        blocks.forEach(block => {
            const divisor = block.querySelector(".comparison__before"),
                  slider = block.querySelector(".comparison__range");
            let animationFrame;
            let direction = 1;
            let isInteracted = false;
            let progress = 0.5;
            let lastTime = performance.now();
            const speed = 0.0004; // скорость анимации

            const easeInOut = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

            const moveDivisor = () => { 
                divisor.style.width = slider.value + "%";
            };

            const animateSlider = (timestamp) => {
                if (isInteracted || !isElementInViewport(block)) {
                    cancelAnimationFrame(animationFrame);
                    animationFrame = null;
                    return;
                }
                const deltaTime = timestamp - lastTime;
                lastTime = timestamp;
                progress += (speed * deltaTime) * direction;
                if (progress >= 1) {
                    progress = 1;
                    direction = -1;
                } else if (progress <= 0) {
                    progress = 0;
                    direction = 1;
                }
                const value = 10 + easeInOut(progress) * 80;
                slider.value = value;
                moveDivisor();
                commonProgress = progress; // синхронизируем с глобальным значением
                animationFrame = requestAnimationFrame(animateSlider);
            };

            slider.addEventListener('input', () => {
                isInteracted = true;
                moveDivisor();
                cancelAnimationFrame(animationFrame);
            });

            slider.addEventListener('mouseup', () => {
                isInteracted = false;
                progress = commonProgress;
                lastTime = performance.now();
                animateSlider(lastTime);
            });

            slider.addEventListener('touchend', () => {
                isInteracted = false;
                progress = commonProgress;
                lastTime = performance.now();
                animateSlider(lastTime);
            });

            slider.addEventListener('touchstart', () => {
                isInteracted = true;
                cancelAnimationFrame(animationFrame);
            });

            slider.addEventListener('touchmove', () => {
                isInteracted = true;
                cancelAnimationFrame(animationFrame);
            });

            window.addEventListener('scroll', () => {
                if (!isInteracted && isElementInViewport(block) && !animationFrame) {
                    lastTime = performance.now();
                    animateSlider(lastTime);
                }
            }, { passive: true });

            animateSlider(lastTime);
        });

        document.querySelectorAll('.comparison__range').forEach(rangeInput => {
            rangeInput.addEventListener('touchstart', function(e) {
                e.preventDefault();
                const touch = e.targetTouches[0];
                const value = Math.round((touch.pageX - this.getBoundingClientRect().left) / this.offsetWidth * 100);
                this.value = value;
                const event = new Event('input', { bubbles: true });
                this.dispatchEvent(event);
            });

            rangeInput.addEventListener('touchmove', function(e) {
                e.preventDefault();
                const touch = e.targetTouches[0];
                const value = Math.round((touch.pageX - this.getBoundingClientRect().left) / this.offsetWidth * 100);
                this.value = value;
                const event = new Event('input', { bubbles: true });
                this.dispatchEvent(event);
            });
        });

        // Скроллбар
        const container = document.querySelector(".comparison__wrapper");
        const scrollbar = document.querySelector(".comparison__scrollbar");
        const thumb = document.querySelector(".comparison__scrollbar-thumb");

        if (container && scrollbar && thumb) {
            const updateThumb = () => {
                const scrollableWidth = container.scrollWidth - container.clientWidth;
                if (scrollableWidth <= 0) return;
                const scrollRatio = container.scrollLeft / scrollableWidth;
                const maxThumbMove = scrollbar.clientWidth - thumb.clientWidth;
                thumb.style.transform = `translateX(${scrollRatio * maxThumbMove}px)`;
            };

            const moveScrollbar = (clientX) => {
                const rect = scrollbar.getBoundingClientRect();
                const offsetX = clientX - rect.left;
                const clickRatio = offsetX / scrollbar.clientWidth;
                const scrollableWidth = container.scrollWidth - container.clientWidth;
                if (scrollableWidth <= 0) return;
                container.scrollLeft = clickRatio * scrollableWidth;
                updateThumb();
            };

            let isDragging = false;
            let dragStartX = 0;
            let initialScrollLeft = 0;

            const startDrag = (clientX) => {
                isDragging = true;
                dragStartX = clientX;
                initialScrollLeft = container.scrollLeft;
            };

            const duringDrag = (clientX) => {
                if (!isDragging) return;
                const deltaX = clientX - dragStartX;
                const scrollbarWidth = scrollbar.clientWidth - thumb.clientWidth;
                const scrollableWidth = container.scrollWidth - container.clientWidth;
                if (scrollbarWidth <= 0 || scrollableWidth <= 0) return;
                const scrollDelta = deltaX * (scrollableWidth / scrollbarWidth);
                container.scrollLeft = initialScrollLeft + scrollDelta;
                updateThumb();
            };

            const endDrag = () => {
                isDragging = false;
            };

            thumb.addEventListener("mousedown", (e) => {
                e.stopPropagation();
                thumb.style.cursor = "grabbing";
                startDrag(e.clientX);
            });

            document.addEventListener("mousemove", (e) => {
                duringDrag(e.clientX);
            });

            document.addEventListener("mouseup", () => {
                thumb.style.cursor = "grab";
                endDrag();
            });

            thumb.addEventListener("touchstart", (e) => {
                e.stopPropagation();
                const touch = e.touches[0];
                startDrag(touch.clientX);
            });

            thumb.addEventListener("touchmove", (e) => {
                const touch = e.touches[0];
                duringDrag(touch.clientX);
                e.preventDefault();
            });

            thumb.addEventListener("touchend", endDrag);

            scrollbar.addEventListener("mousedown", (e) => {
                if (e.target !== thumb) {
                    moveScrollbar(e.clientX);
                }
            });

            scrollbar.addEventListener("touchstart", (e) => {
                if (e.target !== thumb) {
                    const touch = e.touches[0];
                    moveScrollbar(touch.clientX);
                }
            });

            container.addEventListener("scroll", updateThumb, { passive: true });
            updateThumb();
        }
    }
})();

// close bitrix24
(function () {
    window.addEventListener('load', () => {

        setTimeout(() => {
            const closeBtn = document.querySelector('.b24-widget-button-popup-btn-hide')
            if (!closeBtn) return;
            closeBtn.click()
        }, 5000);
    })
})();
// close bitrix24  

// cart toast
(function () {
  let cartToastTimeout;
  let cartToastDelayTimeout;

  const toastSelector = '.cart__toast';
  const closeBtnSelector = '.cart__toast_close';
  const visibleClass = 'cart__toast--visible';
  const sessionKey = 'cart_toast_closed';

  function showCartToast() {
    if (sessionStorage.getItem(sessionKey)) {
      return;
    }

    const toast = document.querySelector(toastSelector);
    if (!toast) {
      return;
    }

    // Показываем
    toast.classList.add(visibleClass);

    // Скрываем через 10 секунд
    cartToastTimeout = setTimeout(() => {
      hideCartToast();

      // Повторно показать через 15 секунд
      cartToastDelayTimeout = setTimeout(showCartToast, 15000);
    }, 10000);
  }

  function hideCartToast() {
    const toast = document.querySelector(toastSelector);
    if (!toast) return;
    toast.classList.remove(visibleClass);
  }

  function handleManualClose() {
    sessionStorage.setItem(sessionKey, 'true');
    hideCartToast();
    clearTimeout(cartToastTimeout);
    clearTimeout(cartToastDelayTimeout);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const closeBtn = document.querySelector(closeBtnSelector);
    if (closeBtn) {
      closeBtn.addEventListener('click', handleManualClose);
    }

    setTimeout(() => {
      showCartToast();
    }, 2000);
  });
})();
// cart toast


// product options hover on mobile (инициализация при появлении секции с опциями в viewport)
(function () {
  const configSection = document.querySelector('.product__config_image, .config_container, [data-dropdown]');
  if (!configSection) return;

  function initProductOptionsTouch() {
    const touchImages = document.querySelectorAll('.default_option img, .lip__item img');
    touchImages.forEach(img => {
      img.addEventListener('touchstart', () => {
        img.classList.add('tapped');
        setTimeout(() => img.classList.remove('tapped'), 1000);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function runWhenReady() {
    const io = new IntersectionObserver((entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      initProductOptionsTouch();
    }, { threshold: 0.1 });
    io.observe(configSection);
  });
})();
// product options hover on mobile



(function () {
  if (document.querySelector('.drawer__progress_products')) {
    window.initDrawerProgressUpsell();
  }
})();

// offer timer (lazy init)
(function () {
  var timerRoots = document.querySelectorAll('.offer-timer-section');
  if (!timerRoots.length) return;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function getMonthEndDate() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0);
  }

  function createTimer(root) {
    var daysEl = root.querySelector('[data-offer-days]');
    var hoursEl = root.querySelector('[data-offer-hours]');
    var minutesEl = root.querySelector('[data-offer-minutes]');
    var secondsEl = root.querySelector('[data-offer-seconds]');
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return null;

    var intervalId = null;
    var started = false;

    function render() {
      var now = new Date();
      var end = getMonthEndDate();
      var diff = end.getTime() - now.getTime();

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    function start() {
      if (started) return;
      started = true;
      render();
      intervalId = setInterval(render, 1000);
    }

    function stop() {
      if (!intervalId) return;
      clearInterval(intervalId);
      intervalId = null;
      started = false;
    }

    return { root: root, start: start, stop: stop };
  }

  var timers = [];
  timerRoots.forEach(function (root) {
    var timer = createTimer(root);
    if (timer) timers.push(timer);
  });
  if (!timers.length) return;

  function startTimerWhenVisible(timer) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries || !entries.length) return;
        if (entries[0].isIntersecting) {
          timer.start();
          observer.disconnect();
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(timer.root);
    } else {
      timer.start();
    }
  }

  timers.forEach(startTimerWhenVisible);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      timers.forEach(function (timer) { timer.stop(); });
    } else {
      timers.forEach(startTimerWhenVisible);
    }
  });
})();

// toggle header car dropdown
(function () {
    function syncHeaderCarFromStorage() {
        var headerCar = document.querySelector('.header__car--desktop');
        if (!headerCar) return;
        var brandEl = headerCar.querySelector('.header__car_info_brand');
        var modelEl = headerCar.querySelector('.header__car_info_model');
        var yearEl = headerCar.querySelector('.header__car_info_year');
        if (!brandEl || !modelEl || !yearEl) return;
        try {
            var saved = localStorage.getItem('carFilterSelections');
            if (!saved) return;
            var data = JSON.parse(saved);
            var brand = (data.brand || '').trim();
            var model = (data.model || '').trim();
            var years = (data.years || '').trim();
            brandEl.textContent = brand;
            modelEl.textContent = model;
            yearEl.textContent = years;
            headerCar.classList.toggle('active', !!(brand || model || years));
        } catch (error) {
            console.error('Error parsing localStorage for header__car:', error);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncHeaderCarFromStorage);
    } else {
        syncHeaderCarFromStorage();
    }

    function finishHeaderCarDropdownLoad(dropdown) {
        if (dropdown) dropdown.classList.remove('is-loading');
    }

    function loadHeaderCarDropdown(dropdown) {
        if (!dropdown || window.__evamatsHeaderCarFilterReady || dropdown.classList.contains('is-loading')) return;

        dropdown.classList.add('is-loading');

        ensureSearchModelsJs(function () {
            if (typeof window.__evamatsEnsureCarFilterJson === 'function') {
                window.__evamatsEnsureCarFilterJson()
                    .then(function () {
                        window.__evamatsHeaderCarFilterReady = true;
                        finishHeaderCarDropdownLoad(dropdown);
                    })
                    .catch(function () {
                        finishHeaderCarDropdownLoad(dropdown);
                    });
            } else {
                finishHeaderCarDropdownLoad(dropdown);
            }
        });
    }

    document.addEventListener('evamats:search-models-error', function () {
        document.querySelectorAll('.header__car_dropdown.is-loading').forEach(finishHeaderCarDropdownLoad);
    });

    document.addEventListener("click", function(e) {
        if (e.target.closest('.header__car_dropdown .filter-container-json')) {
            var dropdown = e.target.closest('.header__car_dropdown');
            loadHeaderCarDropdown(dropdown);
        }

        const trigger = e.target.closest(".header__car");
        const allDropdowns = document.querySelectorAll(".header__car_dropdown");

        // Клик по кнопке (открыть/закрыть)
        if (trigger) {
            const dropdown = trigger.nextElementSibling;

            // Закрываем все остальные
            allDropdowns.forEach(d => {
                if (d !== dropdown) d.classList.remove("active");
            });

            // Тогглим текущий
            dropdown.classList.toggle("active");

            if (dropdown.classList.contains('active')) {
                loadHeaderCarDropdown(dropdown);
            }
            return;
        }

        // Клик вне любых дропдаунов (закрыть всё)
        if (!e.target.closest(".header__car_dropdown")) {
            allDropdowns.forEach(d => d.classList.remove("active"));
        }
    });
})();

/** Consent checkbox gate: one handler for all forms using data-consent-gate* */
(function () {
    var DEFAULT_MSG = 'Musisz zaakceptować politykę prywatności i regulamin.';
    try {
        window.__evamatsConsentGateMsg = DEFAULT_MSG;
    } catch (e1) {}
    document.addEventListener(
        'click',
        function (e) {
            var submitBtn = e.target.closest('[data-consent-gate-submit]');
            if (!submitBtn) return;
            var root = submitBtn.closest('[data-consent-gate]');
            if (!root) {
                var form = submitBtn.closest('form');
                root = form ? form.querySelector('[data-consent-gate]') : null;
            }
            if (!root) return;
            var checkbox = root.querySelector('[data-consent-gate-checkbox]');
            var output = root.querySelector('[data-consent-gate-output]');
            if (!checkbox || !output) return;
            if (!checkbox.checked) {
                e.preventDefault();
                var msg = root.getAttribute('data-consent-gate-msg');
                output.textContent = msg && String(msg).trim() ? String(msg).trim() : DEFAULT_MSG;
                output.style.display = 'block';
                return;
            }
            output.textContent = '';
            output.style.display = 'none';
        },
        true
    );
})();


